import * as React from 'react';
import { useRecoilValue } from 'recoil';
import { AAdditionalColumns } from '../../../../atoms/additionalColumns';
import Dropdown from '../../../../components_v2/dropdown/Dropdown';
import { setLocalStorage } from '../../../../helpers/localStorage';
import { Translate } from '../../../../styles/global/translate';
import { ConstraintType, ModalCalendarH4, ModalCalendarP, ModalCalendarSettingsDescriptionAndDropdown, OPTIMIZATION_RIGHT_PANEL_WIDTH_WITHOUT_PADDING } from '../ModalCalendar';
import { ConstraintProps } from './constraints';

const key = 'OpeningTimes';
type Key = typeof key;

export default function OpeningTimesConstraint(props: ConstraintProps) {
	const additionalColumns = useRecoilValue(AAdditionalColumns);
	const [constraints, setConstraints] = props.constraintsHook;
	const settings = constraints.get(key) as ConstraintType[Key]['settings'];
	const defaultConstraint = props.defaultConstraints[key];

	return <>
		<ModalCalendarH4>{defaultConstraint.label}</ModalCalendarH4>
		<ModalCalendarSettingsDescriptionAndDropdown>
			<ModalCalendarP><Translate id='temporal_constrains_description' /></ModalCalendarP>
			<Dropdown
				isMulti
				dropdownStyle={{
					optionWidth: `${OPTIMIZATION_RIGHT_PANEL_WIDTH_WITHOUT_PADDING}px`,
					optionHeight: '260px',
					width: '100%',
					containerWidth: '100%',
					optionBlockHeight: '34px'
				}}
				checkbox
				doNotDeleteOptionOnSelect
				datalist={additionalColumns.filter(c => c.type === 'Hours').map(ac => ({
					value: ac.id,
					label: ac.name,
					checked: settings?.has(ac.id) ?? false
				}))}
				name={'Hour_number_dropdown'}
				onChange={values => setConstraints(c => {
					const lst = values.map(v => v.value);
					setLocalStorage(key, lst);
					const new_settings = new Set(lst);
					c.set(key, new_settings);
					return new Map(c);
				})}
			/>
		</ModalCalendarSettingsDescriptionAndDropdown>
	</>;
}
